<a (click)='collapse = !collapse' class='panel-heading collapsed'>
  <h4 class='panel-title pointer'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.PAYMENT_MEAN.TITLE' | translate }} <span class='collapse-button-span'><i class='fa collapse-button' [ngClass]="{'fa-chevron-up': collapse, 'fa-chevron-down': !collapse}" aria-hidden='true' alt='collapse_arrow'></i></span></h4>
</a>

<div id='collapseOne' class='panel-collapse in collapse collapsible' [@collapse]='collapse'>
  <div class='panel-accordion-subscription-body'>

    <!-- PAYMENT MEAN ID -->
    <div class='form-group'>
      <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.PAYMENT_MEAN.ID' | translate }}</label>
      <div class='col-sm-6 col-md-6 col-xs-6'><code>{{ paymentMean?.paymentMeanId | noData }}</code></div>
    </div>

    <!-- PAYMENT MEAN STATUS -->
    <div class='form-group'>
      <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.PAYMENT_MEAN.PAYMENT_MEAN_STATUS' | translate }}</label>
      <div class='col-sm-6 col-md-6 col-xs-6'>@if (paymentMean?.status) {
        <status-label [status]='paymentMean?.status'></status-label>
      }</div>
    </div>

    <!-- PAYMENT MEAN NAME -->
    <div class='form-group'>
      <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.PAYMENT_MEAN.NAME' | translate }}</label>
      <div  class='col-sm-6 col-md-6 col-xs-6'>{{ paymentMean?.name ? "\"" + paymentMean?.name + "\"" : '-' }}</div>
    </div>

    <!-- PAYMENT MEAN REFERENCE -->
    <div class='form-group'>
      <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.PAYMENT_MEAN.REFERENCE' | translate }}</label>
      <div  class='col-sm-6 col-md-6 col-xs-6'>{{ paymentMean?.reference | noData }}</div>
    </div>

    <!-- PAYMENT MEAN DESCRIPTION -->
    <div class='form-group'>
      <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.PAYMENT_MEAN.DESCRIPTION' | translate }}</label>
      <div class='col-sm-6 col-md-6 col-xs-6'>{{ paymentMean?.description | noData }}</div>
    </div>

    <!-- PAYMENT MEAN TYPE -->
    <div class='form-group'>
      <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.PAYMENT_MEAN.TYPE' | translate }}</label>
      <div class='col-sm-6 col-md-6 col-xs-6'>{{ 'USER.TABS.IDENTITY.SECTIONS.PAYMENT_DATA.PAYMENT_MEAN.TYPE_STATUS.' + paymentMean?.type | translate | noData }}</div>
    </div>

    <!-- PAYMENT MEAN CREATION DATE -->
    <div class='form-group'>
      <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.PAYMENT_MEAN.CREATION_DATE' | translate }}</label>
      <div class='col-sm-6 col-md-6 col-xs-6'>{{ paymentMean?.creationDate | date : "dd/MM/yyyy 'à' HH:mm" | noData }}</div>
    </div>

    <!-- PAYMENT MEAN MODIFICATION DATE -->
    <div class='form-group'>
      <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.PAYMENT_MEAN.MODIFICATION_DATE' | translate }}</label>
      <div class='col-sm-6 col-md-6 col-xs-6'>{{ paymentMean?.modificationDate | date : "dd/MM/yyyy 'à' HH:mm" | noData }}</div>
    </div>

    <!-- EXPIRATION DATE -->
    <div class='from-group'>
      <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.ACCOUNT.PAYMENT_MEAN.EXPIRATION_DATE' | translate }}</label>
      <div class='col-sm-6 col-md-6 col-xs-6'>{{ paymentMean?.expirationDate | date : 'dd/MM/yyyy' | noData }}</div>
    </div>

  </div>
</div>

